import { Box, Button, Typography, Alert, Paper, Link } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { colors, borderRadius, shadows } from '../theme';
import { NAVIGATION_CONFIG } from "../config/api";
import { useState } from "react";
import logo from "../assets/OC_Logo.png";
import medicImage from "../assets/hero-image.png";

export default function Login() {
  const { instance } = useMsal();
  const [error, setError] = useState<string | null>(null);
  const handleLogin = async () => {
    try {
      setError(null);
      await instance.loginRedirect({
        ...loginRequest,
        redirectStartPage: NAVIGATION_CONFIG.ROUTES.CUSTOMERS,
      });
    } catch (error) {
      console.error("Login failed:", error);
      setError(
        error instanceof Error ? error.message : "Unknown error occurred"
      );
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        backgroundColor: colors.background.default,
        "&::before": {
          content: '""',
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundImage: `url(${medicImage})`,
          backgroundSize: "contain",
          backgroundPosition: "left center",
          backgroundRepeat: "no-repeat",
          zIndex: 0,
          opacity: 0.95,
        },
      }}
    >
      {/* Heading Text */}
      <Box
        sx={{
          position: "absolute",
          left: "5vw",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 1,
          color: "black",
          textShadow: "0 2px 4px rgba(255,255,255,0.3)",
          maxWidth: "40vw",
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontFamily: "Bespoke Slab Variable",
            fontWeight: 700,
            mb: 2,
            fontSize: "80px",
            lineHeight: "88px",
            letterSpacing: "-0.02em",
          }}
        >
          Your Online
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontFamily: "Bespoke Slab Variable",
            fontWeight: 700,
            fontSize: "80px",
            lineHeight: "88px",
            letterSpacing: "-0.02em",
          }}
        >
          Care Platform.
        </Typography>
      </Box>

      {/* Login Form */}
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          maxWidth: "400px",
          minHeight: "550px",
          p: 4,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "white",
          borderRadius: "20px",
          m: 2,
          position: "relative",
          zIndex: 1,
          boxShadow: shadows.lg,
          marginLeft: "auto",
          marginRight: "10%",
        }}
      >
        {/* Logo */}
        <Box sx={{ mb: 4, display: "flex", justifyContent: "flex-start" }}>
          <img src={logo} alt="On-Time Logo" style={{ height: "80px" }} />
        </Box>
        <Typography variant="h4" component="h1" sx={{ mb: 2, fontWeight: 500 }}>
          Log In
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Enter your details below to access your account and explore everything
          waiting for you.
        </Typography>
        <Button
          fullWidth
          variant="contained"
          onClick={handleLogin}
          sx={{
            mt: 2,
            mb: 3,
            py: 1.5,
            backgroundColor: colors.brand.purple,
            fontWeight: 500,
            borderRadius: `${borderRadius.medium}px`,
            "&:hover": {
              backgroundColor: "#3a0066",
            },
            transition: "all 0.3s ease",
          }}
        >
          Sign in with Microsoft
        </Button>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
        <Box
          sx={{
            mt: "auto",
            pt: 4,
            display: "flex",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <Link
            href="#"
            underline="hover"
            color="text.secondary"
            variant="body2"
          >
            Privacy Policy
          </Link>
          <Link
            href="#"
            underline="hover"
            color="text.secondary"
            variant="body2"
          >
            Cookies
          </Link>
        </Box>
      </Paper>
    </Box>
  );
}
